import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findPercentage = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/percentage?` + params,
        method: 'GET'
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET'
    })
}
export const findCitys = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET'
    })
}
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET'
    })
}
export const findPercentageDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/percentage/${id}`,
        method: 'GET'
    })
}
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource/fields`,
        method: 'GET'
    })
}
/**
 * 数据源
 */
export const findDataSourceAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource`,
        method: 'GET'
    })
}

export const addPercentage = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/percentage`,
        method: 'POST',
        data: params
    })
}
export const editPercentage = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/percentage`,
        method: 'PUT',
        data: params
    })
}

export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/percentage/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}







